export const normalizeValue = (value, isPercent = false) => {
  if (!value) {
    return '-';
  }
  const val = parseFloat(value);
  const newVal = Number.isNaN(val) ? '-' : val.toFixed(2);
  return isPercent ? `${newVal}%` : newVal;
};

export const top10Holdings = holdings =>
  [...holdings].sort((a, b) => a.rank - b.rank).slice(0, 10);

export const isDataNull = data => {
  return !data || !data.length;
};

export const getHoldingsTitle = (bond, holdings) => {
  if (bond) {
    if (holdings[0]?.issuerGuarantorTypeName === 'Issuer') {
      return 'Top 10 Issuers';
    }
    return 'Top 10 Guarantors';
  }
  return 'Top 10 Holdings';
};
